import React from "react";
import { formHandler } from "@utils/general";
import Grid from "@mui/material/Grid2";
import AddressModal from "../AddressesModal";
import { ui } from '../../../interfaces/interfaces';
import useDebugInformation from '../../../hooks/useDebugInformation';
import Stack from "@mui/material/Stack";
import MemoizedFormInput from "../MemoizedFormInput";
import { AddressPrefix } from "@utils/BasicTypes";
import { useAppSelector } from "@store/hooks";
import OptionalSwitches from "../OptionalSwitches";
import ActionButtons from "./ActionButtons";
import MemoizedPostcodeInput from "./MemoizedPostcodeInput";
import Property from "./Property";

const name = "AddressTab"
const form = formHandler(ui)

type Props = {
    prefix: Exclude<AddressPrefix, "Landlord" | "Related">
    children: any
    parent: string
}

const AddressTab: React.FC<Props> = ({ parent, prefix, children }) => {
    const a11Props = React.useMemo(() => ({ children }), [children])

    const modal = useAppSelector(({ ui }) => ui[`${prefix}ModalOpen`])
    const isBusiness = useAppSelector(({ ui }) => ui[`${prefix}IsBusiness`])
    const asProperty = useAppSelector(({ ui }) => ui[`${prefix}AsProperty`])
    const debugName = `${parent}▷[${name}]`

    const validatedPrefix = React.useMemo(() => asProperty ? "PropertyAddress" : prefix, [asProperty, prefix])

    useDebugInformation(debugName, { prefix, children, isBusiness, modal })
    return (
        <Stack spacing={1} >
            <Grid container spacing={1} >
                {isBusiness && (<MemoizedFormInput form={form} inputName="BusinessName" parent={debugName} prefix={validatedPrefix} xs={12} sm={12} disabled={asProperty} />)}

                <Property form={form} inputName="Property" parent={debugName} prefix={validatedPrefix} xs={12} sm={12} disabled={asProperty} />
                <MemoizedFormInput form={form} inputName="Street" parent={debugName} prefix={validatedPrefix} xs={12} sm={12} disabled={asProperty} />
                <MemoizedFormInput form={form} inputName="City" parent={debugName} prefix={validatedPrefix} xs={12} sm={6} disabled={asProperty} />
                <MemoizedFormInput form={form} inputName="Locality" parent={debugName} prefix={validatedPrefix} xs={12} sm={6} disabled={asProperty} />
                <MemoizedPostcodeInput form={form} inputName="Postcode" parent={debugName} prefix={validatedPrefix} xs={6} sm={6} disabled={asProperty} />
                <MemoizedFormInput form={form} inputName="Country" parent={debugName} prefix={validatedPrefix} xs={12} sm={6} disabled={asProperty} />
            </Grid>
            {a11Props.children && <OptionalSwitches >{a11Props.children}</OptionalSwitches>}
            <ActionButtons form={form} parent={debugName} prefix={validatedPrefix} asProperty={asProperty} />
            {modal && !["LandlordAddress","RelatedAddress"].includes(validatedPrefix) && <AddressModal prefix={validatedPrefix} />}
        </Stack >
    )
};

export default React.memo(AddressTab);
